import React from 'react';
import { LoadTicketFilters } from '../../../../app/models/LoadTicket';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

type Props = {
    filter: LoadTicketFilters;
    setFilter: (filter: LoadTicketFilters) => void;
    onSearch: () => void;
};

const LoadTicketFilter = ({ filter, setFilter, onSearch }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="transport_order_id">
                            Orden de transporte
                        </label>
                        <input
                            title="Orden de transporte"
                            type="text"
                            id="transport_order_id"
                            name="transport_order_id"
                            className="form-control form-control-sm"
                            value={filter.transport_order_id ?? ''}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="issue_date">
                            Fecha de emisión
                        </label>
                        <input
                            title="Fecha de emisión"
                            type="date"
                            id="issue_date"
                            name="issue_date"
                            className="form-control form-control-sm"
                            value={filter.issue_date}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className='col-md-auto'>
                    <div style={{marginTop: '22px'}}>
                        <ButtonSearchFilter callbackSearch={onSearch}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadTicketFilter;
